module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_japan.468d3473.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_japan.png
// module id = 1195
// module chunks = 16